import {
  MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE,
  MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW,
  MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE,
} from "../i18n/keysTranslations.js";

export const MAX_LINKEDIN_LEAD_FORM_QUESTIONS = 12;

export const DEFAULT_LINKEDIN_LEAD_FORM_CALL_TO_ACTION =
  "VISIT_COMPANY_WEBSITE";

export const LINKEDIN_LEAD_FORM_CALL_TO_ACTION_OPTIONS = [
  {
    value: DEFAULT_LINKEDIN_LEAD_FORM_CALL_TO_ACTION,
    label: MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE,
  },
  { value: "LEARN_MORE", label: MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE },
  { value: "VIEW_NOW", label: MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW },
  { value: "DOWNLOAD_NOW", label: MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW },
  { value: "TRY_NOW", label: MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW },
];

export const DEFAULT_LINKEDIN_LEAD_FORM_PROFILE_FIELDS = [
  "FIRST_NAME",
  "LAST_NAME",
  "EMAIL",
  "LINKEDIN_PROFILE_LINK",
];

// Shared with ModalCreateLeadForm and the recommendation prefill.
export const LINKEDIN_LEAD_FORM_FIELD_LIMITS = {
  name: 256,
  headline: 60,
  description: 160,
  url: 2000,
  legalDisclaimer: 2000,
  thankYouMessage: 300,
};
